export const assetUrl = (asset: string) => {
  return "https://assets.kei.fi/core-ui/" + asset;
};
